// js
import { connect } from 'react-redux';
import SourcesCard from '../../components/sources/SourcesCard';
import { makeGetIsActiveArea } from '../../selectors/dsa/areaSelectors';
import { makeGetAreaSourcesStats, makeGetAreaSourcesCompletionProgress } from '../../selectors/dsa/sourcesSelectors';


const mapStateToProps = (state, props) => {
  const getIsActiveArea = makeGetIsActiveArea();
  const getAreaSourcesCompletionProgress = makeGetAreaSourcesCompletionProgress();
  const getAreaSourcesStats = makeGetAreaSourcesStats();

  return {
    isActiveArea: getIsActiveArea(state, props),
    stats: getAreaSourcesStats(state, props),
    progress: getAreaSourcesCompletionProgress(state, props)
  };
};

export default connect(mapStateToProps)(SourcesCard);



// WEBPACK FOOTER //
// ./src/containers/sources/SourcesCard.js